"use strict";
/*
  Import specific illustrations. Note that this needs to use the "import" syntax because newer versions of
  CRA do not support the old "require" syntax. TS is also having issues detecting that these files
  exist (they do), so we are keeping these declarations in their own file so we can tell the
  compiler to quit whining. And tell Eslint to quit whining about us telling tsc to quit whining.

  TODO: reference an actual web-hosted URL like sane people (probably static/gds)
*/
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// Static asset location
var assetLoc = "https://static.granular.ag/common/gds-assets/latest/lib/images/illustrations";
var GILCloudCover = assetLoc + "/GIL-cloud-cover.svg";
var GILDocumentCheck = assetLoc + "/GIL-document-check.svg";
var GILDocument = assetLoc + "/GIL-document.svg";
var GILEmailConfirmed = assetLoc + "/GIL-email-confirmed.svg";
var GILEmailOpen = assetLoc + "/GIL-email-open.svg";
var GILEmail = assetLoc + "/GIL-email.svg";
var GILFieldLayers = assetLoc + "/GIL-field-layers.svg";
var GILField = assetLoc + "/GIL-field.svg";
var GILKey = assetLoc + "/GIL-key.svg";
var GILLockedCheck = assetLoc + "/GIL-locked-check.svg";
var GILLocked = assetLoc + "/GIL-locked.svg";
var GILPeople = assetLoc + "/GIL-people.svg";
var GILSatellite = assetLoc + "/GIL-satellite.svg";
var GILUnlockedCheck = assetLoc + "/GIL-unlocked-check.svg";
var GILUnlocked = assetLoc + "/GIL-unlocked.svg";
exports.default = {
    GILCloudCover: GILCloudCover,
    GILDocumentCheck: GILDocumentCheck,
    GILDocument: GILDocument,
    GILEmailConfirmed: GILEmailConfirmed,
    GILEmailOpen: GILEmailOpen,
    GILEmail: GILEmail,
    GILFieldLayers: GILFieldLayers,
    GILField: GILField,
    GILKey: GILKey,
    GILLockedCheck: GILLockedCheck,
    GILLocked: GILLocked,
    GILPeople: GILPeople,
    GILSatellite: GILSatellite,
    GILUnlockedCheck: GILUnlockedCheck,
    GILUnlocked: GILUnlocked,
};
